export const createFixture = <T>(defaultData: T) => (overrides?: Partial<T>): T => ({
    ...defaultData,
    ...overrides,
});
